// React
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CybsListbox from '@cybs-ui/components/lib/listbox';
import styles from './component.styles';

// CYBS-UI

const CSS_PREFIX = 'vds-menu';

const CybsMenu = forwardRef(
  (
    {
      children,
      className,
      customCSS,
      dataTest,
      onListKeyDown,
      onListSelect,
      onListScrollBottom,
      show,
      id,
      ...props
    },
    ref
  ) => (
    <div
      className={classnames(`${CSS_PREFIX}-curtain`, {
        [`${CSS_PREFIX}--show`]: Boolean(show)
      })}
      css={theme => [styles(theme), customCSS(theme)]}
      data-test={`${dataTest}-cybsMenu`}
      ref={ref}
    >
      <CybsListbox
        id={id}
        dataTest={dataTest}
        onKeyDown={onListKeyDown}
        onSelect={onListSelect}
        onScrollBottom={onListScrollBottom}
        menuRef={ref}
        {...props}
      >
        {children}
      </CybsListbox>
    </div>
  )
);

CybsMenu.propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string
    })
  ),

  /**
   * @ignore
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Styling function to allow CSS overrides via Emotion
   *
   * @ignore
   */
  customCSS: PropTypes.func,

  /**
   * dataTest string for testing.
   */
  dataTest: PropTypes.string.isRequired,

  /**
   * Callback fired when an item is selected.
   */
  onListKeyDown: PropTypes.func,

  /**
   * Callback fired on key down.
   */
  onListSelect: PropTypes.func,

  /**
   * Callback fired when scroll reaches bottom of scrollable list
   */
  onListScrollBottom: PropTypes.func,
  /**
   * Show
   */
  show: PropTypes.bool,

  /**
   * Width of the input and dropdown menu in px or rem.
   */
  width: PropTypes.string
};

CybsMenu.defaultProps = {
  id: undefined,
  children: undefined,
  className: '',
  customCSS: () => '',
  onListKeyDown: () => {},
  onListSelect: () => {},
  onListScrollBottom: () => {},
  show: false,
  width: ''
};

CybsMenu.displayName = 'CybsMenu';

export default CybsMenu;
